import React from 'react';
import { WrapperSimple, WrapperDashed } from './styles';
export const DelimRenderer = React.memo((props) => {
    const { block } = props;
    const Wrapper = block.kind === 'simple' ? WrapperSimple : WrapperDashed;
    return React.createElement(Wrapper, null);
});
